import React, { useEffect, useState } from "react";
import { useAtom } from "jotai";
import { dashboardCardsData } from "../states/dashboardCardsData";
import { personalData } from "../states/personalData";
import axios from "../axios";
import { useNavigate } from "react-router-dom";
import { alertData } from "../states/alert";
import { logEvent, logPageView } from "../analytics";
import { EVENTS } from "../constants/ga-constants";
import "./student-card.css";
import StudentCardDetailsPopup from "./../components/StudentCardDetails/StudentCardDetails";

import _ from "lodash";

const formatDate = (dateStr) => {
  if (!dateStr || dateStr === "-") return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  const day = d.getDate();
  const month = d.getMonth() + 1;
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatDateTime = (dateStr) => {
  if (!dateStr || dateStr === "-") return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${day}/${month}/${year} at ${hours}:${minutes}${ampm}`;
};

export default function StudentCard({ cardId, distance, amount, is_hotlead }) {
  const [cardsCenteralData, setCardsCenteralData] = useAtom(dashboardCardsData);
  const [personalCenteralData, setPersonalCenteralData] = useAtom(personalData);
  const [currentCard, setCurrentCard] = useState();
  const [alert, setAlert] = useAtom(alertData);
  const [showPopup, setShowPopup] = useState(false);

  const navigation = useNavigate();

  const updateCentralData = (newCentralData) => {
    let updatedCurrentData = { ...currentCard, ...newCentralData };
    setCurrentCard(() => updatedCurrentData);
  };

  const postAppliedJobs = () => {
    axios
      .post("/v1/tutor/applied-jobs", {
        dealings_id: currentCard.dealings_id,
        distance: currentCard.distance,
      })
      .then((response) => {
        if (response.data.is_success) {
          setCardsCenteralData((currentData) => {
            const AppliedJobIds = response.data.data;
            const newData = currentData.map((card) => {
              if (AppliedJobIds.indexOf(parseInt(card.dealings_id)) !== -1) return { ...card, isActive: true };
              return card;
            });
            return newData;
          });

          if (!personalCenteralData.is_paid) {
            logEvent(EVENTS.UNVERIFIED_TUTOR_JOB.event_name);
            navigation("/verify-account");
          } else logEvent(EVENTS.VERIFIED_TUTOR_JOB.event_name);
          setAlert("Successfully Applied, Our CRE will reach out to you soon. ");
        }
      })
      .catch((err) => {
        // console.log("error while appling to job ");
      });
  };

  const updateTutorDemoInterest = (payload) => {
    axios
      .post("/v1/tutor/demo-update-interest", {
        dealings_id: currentCard.dealings_id,
        isInterested: payload.isInterested,
      })
      .then((response) => {
        if (response.data.is_success) {
          setCardsCenteralData((currentData) => {
            const currentDemoShortlistClass = response.data.data;

            const newData = currentData.map((card) => {
              if (card.dealings_id === currentDemoShortlistClass.dealID) {
                return {
                  ...card,
                  status: currentDemoShortlistClass.status,
                };
              }

              return card;
            });
            return newData;
          });

          updateCentralData({
            isActive: true,
            isInterested: payload.isInterested,
            status: "INTERESTED",
            ...response.data,
          });
          setAlert("Your interest has been recorded.");
        }
      })
      .catch((err) => {
        setAlert("Failed to update interest. Please try again.");
      });
  };

  useEffect(() => {
    setCurrentCard(() => cardsCenteralData.find((card) => card.dealings_id === cardId));
  }, [cardId, cardsCenteralData]);

  return currentCard ? (
    <div
      className={`tutor-student-card-wrapper ${personalCenteralData.tutor_verified
        ? "tutor-student-card-wrapper-verified"
        : "tutor-student-card-wrapper-unverified"
        } ${is_hotlead ? "hot-lead-card" : ""}`}
    >
      <div className="tutor-student-card-left-content-wrapper">
        {is_hotlead && (
          <div className="hotlead-container">
            <div className="hotlead-left">
              <div className="hot-lead-badge">
                <img src="./hotlead-icon.svg" alt="hotlead-icon" />
                Hot Lead !
              </div>

              {currentCard.distance < 2 && (
                <span className="hotlead-distance">(Just {currentCard.distance.toFixed(1)} kms away from you)</span>
              )}
            </div>
            <div className="hotlead-right"></div>
          </div>
        )}
        <div className={`container ${currentCard.status === "EXPIRED" ? "expired" : ""}`}>
          <div className="item-1">
            <div className="student-subject-details">
              <div className="tutor-student-card-name">
                <img src="./card-person-icon.svg" alt="card-person-icon" /> {currentCard.student_name}
              </div>
              <div className="tutor-student-card-subjects">
                <img src="./card-subject-icon.svg" alt="card-subject-icon" /> Subjects : {currentCard.subjects}
              </div>
              <div className="tutor-student-card-subjects">
                <img src="./card-subject-icon.svg" alt="card-address-icon" /> Level : {currentCard.level} ,{" "}
                {currentCard.stream}
              </div>

              <div className="tutor-student-card-subjects">
                <img src="./card-subject-icon.svg" alt="card-address-icon" /> Classes/Week : {currentCard.days_per_week}
              </div>

              {currentCard.distance !== undefined && currentCard?.distance !== null ? (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Distance:{" "}
                  {currentCard.distance.toFixed(1)} Km away
                </div>
              ) : (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Distance:{" "}
                </div>
              )}

              {currentCard.address !== "undefined" && currentCard.address && (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Address :{" "}
                  {currentCard.address.split(",").map((val, ind, arr) => (ind < 3 ? val : ""))}
                </div>
              )}
              {(currentCard.address === "undefined" || !currentCard.address) && (
                <div className="tutor-student-card-subjects">
                  <img src="./card-address-icon.svg" alt="card-address-icon" /> Address {currentCard.zip}
                </div>
              )}
            </div>

            <div
              className={`view-details-btn ${currentCard.status === "EXPIRED" ? "expired" : ""}`}
              onClick={() => {
                if (currentCard.status !== "EXPIRED") {
                  setShowPopup(true);
                }
              }}
            >
              View Details
            </div>
            {showPopup && <StudentCardDetailsPopup cardId={cardId} onClose={() => setShowPopup(false)} />}
          </div>
          <div className="item-2 tutor-student-card-right-section">
            <div className="tutor-student-card-right-top">
              {currentCard.new_lead && (
                <div className="tutor-student-card-new-tag-wrapper">
                  <span className="new-tag-badge">New</span>
                </div>
              )}
              {currentCard.status && (
                <div className="tutor-student-card-status-wrapper">
                  {(() => {
                    const statusColorMap = {
                      YET_TO_SCHEDULE: "rgba(255, 153, 0, 1)",
                      ASSIGNED: "rgba(35, 139, 139, 1)",
                      INTERESTED: "rgba(33, 150, 243, 1)",
                      NOT_INTERESTED: "rgba(220, 53, 69, 1)",
                      IN_PROGRESS: "rgba(255, 153, 0, 1)",
                      DEMO_SCHEDULED: "rgba(239, 176, 37, 1)",
                      CONFIRMED: "rgba(40, 167, 69, 1)",
                      EXPIRED: "rgba(154, 154, 154, 1)",
                    };

                    const statusEffectMap = {
                      YET_TO_SCHEDULE: {
                        boxShadow: "0 0 9px rgba(255, 153, 0, 1)",
                        backgroundColor: "rgba(255, 153, 0, 1)",
                      },
                      ASSIGNED: {
                        boxShadow: "0 0 9px rgba(35, 139, 139, 1)",
                        backgroundColor: "rgba(35, 139, 139, 1)",
                      },
                      INTERESTED: {
                        boxShadow: "0 0 9px rgba(33, 150, 243, 1)",
                        backgroundColor: "rgba(33, 150, 243, 1)",
                      },
                      NOT_INTERESTED: {
                        boxShadow: "0 0 9px rgba(220, 53, 69, 1)",
                        backgroundColor: "rgba(220, 53, 69, 1)",
                      },
                      IN_PROGRESS: {
                        boxShadow: "0 0 9px rgba(255, 153, 0, 1)",
                        backgroundColor: "rgba(255, 153, 0, 1)",
                      },
                      DEMO_SCHEDULED: {
                        boxShadow: "0 0 9px rgba(239, 176, 37, 1)",
                        backgroundColor: "rgba(239, 176, 37, 1)",
                      },
                      CONFIRMED: {
                        boxShadow: "0 0 9px rgba(40, 167, 69, 1)",
                        backgroundColor: "rgba(40, 167, 69, 1)",
                      },
                      EXPIRED: {
                        boxShadow: "0 0 9px rgba(154, 154, 154, 1)",
                        backgroundColor: "rgba(154, 154, 154, 1)",
                      },
                    };

                    const normalizedStatus = currentCard.status ?? "YET_TO_SCHEDULE";

                    return (
                      <>
                        {currentCard.card_domain !== "RECOMMENDATION" && (
                          <>
                            <div
                              className="tutor-student-card-status-title"
                              style={{
                                color: statusColorMap[normalizedStatus],
                              }}
                            >
                              {_.startCase(_.toLower(normalizedStatus))}
                            </div>

                            <div
                              className="tutor-student-card-status-blink"
                              style={{
                                boxShadow: statusEffectMap[normalizedStatus]?.boxShadow,
                                backgroundColor: statusEffectMap[normalizedStatus]?.backgroundColor,
                              }}
                            ></div>
                          </>
                        )}
                      </>
                    );
                  })()}
                </div>
              )}
              <div className={`container contact-info ${currentCard.status === "EXPIRED" ? "expired" : ""}`}>
                <div className="item-1 contact-info-col">
                  {(currentCard.card_domain === "DEMO_CLASSES" ||
                    currentCard.card_domain === "MY_CLASSES" ||
                    is_hotlead) && (
                      <div className="tutor-student-card-right-content-wrapper">
                        <div className="tutor-student-card-right-content-1">
                          <div className="contact-info-text">Call Student</div>

                          <div className="tutor-myclasses-call-to-action-icon">
                            {(currentCard.status === "ASSIGNED" ||
                              currentCard.status === "DEMO_SCHEDULED" ||
                              currentCard.card_domain === "MY_CLASSES") &&
                              currentCard.phone ? (
                              <a href={`tel:${currentCard.phone}`} >
                                <img src="./phone-dial-icon.svg" alt="call-to-action-icon" style={{ height: 30, width: 30, marginRight: 0 }} />
                              </a>
                            ) : (
                              <a>
                                <img src="./phone-dial-icon-disabled.svg" alt="call-to-action-icon" style={{ height: 30, width: 30, marginRight: 0 }} />
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                </div>
                <div className="item-2 contact-info-col">
                  {(currentCard.card_domain === "DEMO_CLASSES" ||
                    currentCard.card_domain === "MY_CLASSES" ||
                    is_hotlead) && (
                      <div className="tutor-student-card-right-content-wrapper">
                        <div className="tutor-student-card-right-content-1">
                          <div className="contact-info-text">View Location</div>

                          <div className="tutor-myclasses-call-to-action-icon">
                            {currentCard.location && currentCard.status !== "NOT_INTERESTED" ? (
                              <a href={currentCard.location} target="_blank" rel="noreferrer">
                                <img src="./location.svg" alt="call-to-action-icon" style={{ height: 30, width: 30, marginRight: 0 }} />
                              </a>
                            ) : (
                              <a>
                                <img src="./location-disabled.svg" alt="call-to-action-icon" style={{ height: 30, width: 30, marginRight: 0 }} />
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className="tutor-student-card-right-bottom">
              {currentCard.card_domain === "RECOMMENDATION" && currentCard.amount && (
                <div className="tutor-student-card-right-content-2">
                  <div className="tutor-student-card-right-content-2--btn tutor-forms-next-btn-amount tutor-form-btn-amount-fee">
                    ₹ {currentCard.amount}/Month
                  </div>
                </div>
              )}
              {currentCard.card_domain === "DEMO_CLASSES" && currentCard.status === "YET_TO_SCHEDULE" && (
                <div className="tutor-student-card-right-content-2">
                  <div className="tutor-student-card-demo-text">
                    Are You Interested to go for a demo class?
                  </div>
                </div>
              )}
              {(currentCard.status === "ASSIGNED" && currentCard.card_domain !== "RECOMMENDATION") && (
                <div className="tutor-student-card-right-content-2">
                  <div
                    style={{
                      color: "rgba(39, 65, 120, 1)",
                      fontSize: "14px",
                      fontWeight: 600,
                      lineHeight: "120%",
                      textAlign: "right",
                    }}
                  >
                    Call Student/Parent to Schedule demo class
                  </div>
                </div>
              )}
              {(currentCard.status === "INTERESTED" && currentCard.card_domain !== "RECOMMENDATION") && (
                <div className="tutor-student-card-right-content-2">
                  <div
                    style={{
                      color: "rgba(39, 65, 120, 1)",
                      fontSize: "14px",
                      fontWeight: 600,
                      lineHeight: "120%",
                      textAlign: "right",
                    }}
                  >
                    Your request is being processed. You will be notified Shortly
                  </div>
                </div>
              )}

              {currentCard.status === "DEMO_SCHEDULED" && currentCard.card_domain !== "RECOMMENDATION" && (
                <div className="tutor-student-card-right-content-2">
                  <div
                    style={{
                      color: "rgba(39, 65, 120, 1)",
                      fontSize: "14px",
                      fontWeight: 600,
                      lineHeight: "130%",
                      textAlign: "right",
                    }}
                  >
                    <div>Demo Date & Time</div>
                    <div>{formatDateTime(currentCard.demo_date) || "-"}</div>
                  </div>
                </div>
              )}
              {currentCard.status === "CONFIRMED" && currentCard.card_domain !== "RECOMMENDATION" && currentCard.card_domain !== "MY_CLASSES" && (
                <div className="tutor-student-card-right-content-2">
                  <div
                    style={{
                      color: "rgba(39, 65, 120, 1)",
                      fontSize: "14px",
                      fontWeight: 600,
                      lineHeight: "130%",
                      textAlign: "right",
                    }}
                  >
                    <div>Starting Date</div>
                    <div>{formatDate(currentCard.start_date || currentCard.confirmed_tuition_date) || "-"}</div>
                  </div>
                </div>
              )}
              {currentCard.status === "CANCELLED" && currentCard.card_domain !== "RECOMMENDATION" && (
                <div className="tutor-student-card-right-content-2">
                  <div
                    style={{
                      color: "rgba(39, 65, 120, 1)",
                      fontSize: "14px",
                      fontWeight: 600,
                      lineHeight: "130%",
                      textAlign: "right",
                    }}
                  >
                    <div>Cancelled Date</div>
                    <div>{formatDate(currentCard.cancelled_date || currentCard.updated_at) || "-"}</div>
                  </div>
                </div>
              )}
              {currentCard.card_domain === "RECOMMENDATION" && (
                <div className="tutor-student-card-right-content-2">
                  {currentCard.isActive ? (
                    <div
                      className={`tutor-student-card-right-content-2--btn tutor-forms-next-btn`}
                      style={{
                        backgroundColor: "#eab909",
                        color: "black",
                        fontWeight: 600,
                      }}
                    >
                      Applied
                    </div>
                  ) : (
                    <div
                      className="tutor-student-card-right-content-2--btn tutor-forms-next-btn"
                      onClick={() => {
                        updateCentralData({ isActive: true });
                        postAppliedJobs();
                      }}
                    >
                      Apply
                    </div>
                  )}
                </div>
              )}
              {currentCard.card_domain === "DEMO_CLASSES" && currentCard.status === "YET_TO_SCHEDULE" && (
                <div className="tutor-student-card-right-interested-demo-button-container">
                  <div
                    className="tutor-student-card-right-interested-demo-button"
                    style={
                      currentCard.status === "INTERESTED"
                        ? { backgroundColor: "rgba(39, 65, 120, 1)", color: "white" }
                        : currentCard.status === "NOT_INTERESTED"
                          ? {
                            backgroundColor: "rgba(217, 217, 217, 1)",
                            color: "white",
                            border: "none",
                          }
                          : {}
                    }
                    onClick={
                      ["INTERESTED", "NOT_INTERESTED"].includes(currentCard.status)
                        ? () => {
                          console.log("not clickable");
                        }
                        : () => {
                          updateTutorDemoInterest({ isInterested: true });
                          postAppliedJobs();
                        }
                    }
                  >
                    Yes
                  </div>
                  <div
                    className="tutor-student-card-right-interested-demo-button"
                    style={
                      currentCard.status === "NOT_INTERESTED"
                        ? { backgroundColor: "rgba(39, 65, 120, 1)", color: "white" }
                        : {}
                    }
                    onClick={
                      currentCard.status === "ASSIGNED" || currentCard.status === "YET_TO_SCHEDULE"
                        ? () => {
                          updateTutorDemoInterest({ isInterested: false });
                          postAppliedJobs();
                        }
                        : () => {
                          console.log("not clickable");
                        }
                    }
                  >
                    No
                  </div>
                </div>
              )}
              {currentCard.status === "CONFIRMED" && currentCard.card_domain === "MY_CLASSES" && (
                <div className="tutor-student-card-right-content-2">
                  <button
                    className="mark-attendance-btn"
                    onClick={() => {
                      navigation("/attendance", {
                        state: {
                          tuition: {
                            deal_id: currentCard.dealings_id,
                            student_id: currentCard.studentId,
                            student_name: currentCard.student_name,
                            subject: currentCard.subjects,
                            ...currentCard,
                          },
                          autoShowCalendar: true,
                        },
                      });
                    }}
                  >
                    Mark Attendance
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
